import { defineRecipe } from "shared/components/Spor";

import { defineSemantics } from "shared/theme/sidespor/define/semantics";

export const badgeRecipe = defineRecipe({
  variants: {
    semantic: defineSemantics((theme) => ({
      backgroundColor: theme.colorSemanticFill,
      color: theme.colorSemanticTextMain,
      borderColor: theme.colorSemanticOutline,
      borderWidth: "1px",
    })),
  },
});
